import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { TestFacebookToken } from '@app/pages/Admin/TestFacebookToken'
import { appRoutes } from '@app/routes'

const AdminPagesRouter: React.FC = () => {
  return (
    <Switch>
      <Route
        exact
        path={appRoutes.adminPrivateValidateFbToken.path}
        component={TestFacebookToken}
      />
      <Route>404</Route>
    </Switch>
  )
}
export default AdminPagesRouter
